/**
 * Название и подписи продукта — в одном месте (как brand.json в каркасе бота).
 * Меняете здесь — меняется в приложении, боте и напоминаниях.
 * Заголовок вкладки браузера — в apps/web/index.html (<title>), его тоже поправьте.
 */
export const BRAND = {
  /** Название продукта. */
  name: 'Lullo',
  /** Короткое пояснение после названия. */
  tagline: 'дневник малыша',
  /** Слоган — для онбординга, описания бота и магазинов. */
  slogan: 'Спокойствие для всей семьи',
  /** Подпись кнопки, открывающей мини-приложение из бота (до ~20 символов). */
  openButton: 'Открыть Lullo',
  /** Ник бота по умолчанию (настоящий — BOT_USERNAME в .env). */
  botUsername: 'LulloApp_bot',
  /** Домены. */
  site: 'lullo.ru',
} as const;
